var exports = {
  "kL": "container__I8wld1",
  "zC": "messageContainer__Ml0Y6G",
  "zF": "messageMeta__rKv6cs",
  "As": "truncatedPath__gcninj",
  "Lo": "messageText__AMIxJW",
  "H": "avatarContainer__ORDdhO",
};

module.exports = exports;
